import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'category'
})
export class CategoryPipe implements PipeTransform {
  /**
   1000: "PT_UNSAFE_PATH"              unsafe pedestrian or bicycle
   2000: "PT_MISSING_PATH"             absence of pedestrian or bicycle path
   3000: "PT_UNSAFE_CROSSING"          unsafe crosswalk
   4000: "PT_MISSING_CROSSING"         absence of crosswalk
   5000: "PT_DANGUREOUS_INTERSECTION"  dangerous intersection
   6000: "PT_BAD_ROAD"                 bad road
   7000: "PT_POOR_VISIBILITY"          poor visibility
   8000: "PT_PEOPLE_BEHAVIOR"          traffic behavior
   9000: "PT_FAST_TRAFFIC"             over speed
   10000: "PT_GATHERING_PLACE"         gathering place
   11000: "PT_OTHER"                   others
   * @param value
   * @param args
   */
  transform(value: any, ...args: any[]): any {
    switch (value) {
      case "PT_UNSAFE_PATH":
        return 'unsafe pedestrian or bicycle';
      case "PT_MISSING_PATH":
        return 'absence of pedestrian or bicycle path';
      case "PT_UNSAFE_CROSSING":
        return 'unsafe crosswalk';
      case "PT_MISSING_CROSSING":
        return 'absence of crosswalk';
      case "PT_DANGUREOUS_INTERSECTION":
        return 'dangerous intersection';
      case "PT_BAD_ROAD":
        return 'bad road';
      case "PT_POOR_VISIBILITY":
        return 'poor visibility';
      case "PT_PEOPLE_BEHAVIOR":
        return 'traffic behavior';
      case "PT_FAST_TRAFFIC":
        return 'over speed';
      case "PT_OTHER":
        return 'others';
      case "PT_GATHERING_PLACE":
        return 'gathering place';
      default:
        return '';
    }
  }

}
